<!-- MODAL Datos financieros -->
<div style="overflow-y: auto" mdbModal #datosFinancieros="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: false }">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Datos financieros - RUT {{ clienteSeleccionado?.rutFormato | rut }}
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="datosFinancieros.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <app-clientes-form-datos-financieros [optionsTipoCobro]="optionsTipoCobro"
                    [optionsCondicionPago]="optionsCondicionPago" [optionsListaPrecios]="optionsListaPrecios">
                </app-clientes-form-datos-financieros>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" size="sm" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
                    (click)="datosFinancieros.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <button type="button" size="sm" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
                    (click)="guardarDatosFinancieros()">
                    Guardar
                </button>
            </div>
        </div>
    </div>
</div>